export default __webpack_public_path__ + "background-stuff.88ca44.png";